import pages from '../docs/assistant/pages.json';

export function getAssistantPageTitle(pathname) {
  return pages[pathname] || 'Traciwr';
}
